/**
 * Market sessions in New York time, for the welcome page's status chips.
 * Regular hours only; exchange holidays aren't modeled (the chip says "usually").
 *
 *   CME futures (Globex): Sunday 6pm to Friday 5pm ET, with a daily 5–6pm break.
 *   US stocks:            weekdays 9:30am to 4pm ET.
 */

const DAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

/** Minutes since Sunday 00:00 in New York for a Date. */
export function nyWeekMinute(date = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
  }).formatToParts(date).map((p) => [p.type, p.value]));
  return DAY[parts.weekday] * 1440 + (Number(parts.hour) % 24) * 60 + Number(parts.minute);
}

const at = (day, h, m = 0) => day * 1440 + h * 60 + m;
const WEEK = 7 * 1440;

/** Open windows as [start, end) week minutes. */
const FUTURES = [
  [at(0, 18), at(1, 17)],
  [at(1, 18), at(2, 17)],
  [at(2, 18), at(3, 17)],
  [at(3, 18), at(4, 17)],
  [at(4, 18), at(5, 17)],
];
const STOCKS = [1, 2, 3, 4, 5].map((d) => [at(d, 9, 30), at(d, 16)]);

function status(windows, minute) {
  const open = windows.find(([s, e]) => minute >= s && minute < e);
  if (open) return { open: true, minutesLeft: open[1] - minute };
  const next = windows.map(([s]) => (s > minute ? s - minute : s + WEEK - minute));
  return { open: false, minutesLeft: Math.min(...next) };
}

export function futuresStatus(date) { return status(FUTURES, nyWeekMinute(date)); }
export function stocksStatus(date) { return status(STOCKS, nyWeekMinute(date)); }

/** "3h 12m", "45m", "2d 4h". */
export function formatSpan(minutes) {
  const m = Math.max(0, Math.round(minutes));
  if (m >= 2880) return `${Math.floor(m / 1440)}d ${Math.floor((m % 1440) / 60)}h`;
  if (m >= 60) return `${Math.floor(m / 60)}h ${m % 60}m`;
  return `${m}m`;
}
